import { styled } from 'parkdepot-shared/theme'

export const Text = styled('div', () => ({
    position: 'absolute',
    top: '-2.4rem',
    left: '16rem',
    padding: '2.1rem 2.3rem',
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: '2.4rem',
    fontSize: '1.4rem',
    fontWeight: 500,
    lineHeight: '2rem'
}))

export const Icon = styled('i', ({ $theme }) => ({
    ...$theme.typography.ParagraphLarge,
    color: $theme.colors.primary,
    fontWeight: 600,
    cursor: 'pointer'
}))
